import { pxToRem } from '@noths/polaris-client-styles';
import { css } from 'styled-components';

export const addToBasketAlert = css`
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000;
  display: none;
  width: 100%;

  &[data-visible='true'] {
    display: block;
  }
`;

export const addToBasketAlertTextBox = css`
  &[data-has-focus='true'] {
    box-shadow: 0 0 0 ${pxToRem(2)} var(--neutral-white-base),
      0 0 0 ${pxToRem(4)} var(--brand-purple-base);
  }
`;
